import React, { useState, useEffect } from "react";
import { Images } from "../../../assets/images";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { HyperLink } from "../../common/FormInputs";
import {
  Container,
  HeroContent,
  HeroTitle,
  NumberList,
  List,
  ContentWrapper,
  MainSection,
  ContentBox,
  ImagePlaceholder,
  Description,
  Section,
  SectionHeader,
  SectionContent,
  ContentTitle,
  HeroOverlay,
  ArrowIcon,
} from "./Styles";
import { CSSTransition } from "react-transition-group";

const CorporateShortProgram = () => {
  const [expanded, setExpanded] = useState(null);

  const toggle = (key) => setExpanded(expanded === key ? null : key);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      key: "objectives",
      title: "Course Objectives",
      content: (
        <p>
          Litigation is a costly and energy-consuming process, not to mention
          the copious amount of management time used up in it. Alternative{" "}
          <HyperLink onClick={() => window.open(`https://user.iamch.org.in/`)}>
            Dispute Resolution
          </HyperLink>{" "}
          is a non-adversarial method that delivers substantially better
          outcomes for all involved. This program provides corporate managers
          (legal and otherwise) exposure to the emerging world of mediation so
          they can analyze its efficacy and applicability in corporate disputes.
        </p>
      ),
    },
    {
      key: "learning",
      title: "Learning Objectives",
      content: (
        <NumberList>
          <li>Introduction to ADR.</li>
          <li>What is mediation, its objective and its benefits?</li>
          <li>Mediation vs Litigation - comparative analysis.</li>
          <li>Nature of disputes & personalities in a dispute.</li>
          <li>Structured Process of Mediation.</li>
          <li>Principles of Negotiation.</li>
          <li>Mediation settlement agreement.</li>
          <li>IAMC - Introduction to the platform.</li>
        </NumberList>
      ),
    },
    {
      key: "duration",
      title: "Duration",
      content: (
        <List>
          <li>10 hours of video lectures.</li>
          <li>8 hours of classroom session with one role play.</li>
          <li>Self learning assignments.</li>
        </List>
      ),
    },
    {
      key: "contact",
      title: "Contact",
      content: (
        <p>
          For scheduling a program and pricing enquiries, please contact:
          <div style={{ margin: "10px" }}>
            <b>Email :</b>{" "}
            <a href="mailto:support@justact.co.in">support@justact.co.in</a>
          </div>
          <div style={{ margin: "10px" }}>
            {" "}
            <b>Mobile : </b>+91 95009 09888 | 87545 76111 | 73959 13222
          </div>
        </p>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <title>
          Alternative Dispute Resolution Corporate Training Program - IAMC
        </title>
        <meta
          name="description"
          content="IAMC Corporate Short Training Program aims to provide corporate managers exposure to mediation to analyze its efficacy & applicability in corporate disputes."
        />
        <meta
          name="keywords"
          content="Corporate Dispute Resolution Training, ADR Corporate Training Program, Corporate Short Training Programme, Alternative Dispute Resolution Training, Arbitration Mediation and Conciliation, IAMC"
        />
      </Helmet>

      <Container>
        <Hero bgImage={Images.shortProgram}>
          <HeroOverlay>
            <HeroContent>
              <HeroTitle>Corporate Short Programme</HeroTitle>
            </HeroContent>
          </HeroOverlay>
        </Hero>

        <MainSection>
          <ContentWrapper>
            <ImagePlaceholder bgImage={Images.Negotiation} />
            <ContentBox>
              <ContentTitle>Corporate Short Programme</ContentTitle>
              <Description>
                This document outlines the course and learning objectives of
                this training program.
              </Description>

              {sections.map(({ key, title, content }) => (
                <Section key={key}>
                  <SectionHeader onClick={() => toggle(key)}>
                    <span>{title}</span>
                    <ArrowIcon expanded={expanded === key}>
                      {expanded === key ? "▲" : "▼"}
                    </ArrowIcon>
                  </SectionHeader>

                  <CSSTransition
                    in={expanded === key}
                    timeout={250}
                    classNames="expand"
                    unmountOnExit
                  >
                    <SectionContent>{content}</SectionContent>
                  </CSSTransition>
                </Section>
              ))}
            </ContentBox>
          </ContentWrapper>
        </MainSection>
      </Container>
    </>
  );
};

export default CorporateShortProgram;
